import { MenuItem, MenuList, Paper, Popper } from '@mui/material';
import { CardStatus } from '@src/constants/CardStatus';
import { MutableRefObject } from 'react';

interface Props {
  onRestore(): void;
  onEdit(): void;
  onArchive(): void;
  open: boolean;
  isEdit: boolean;
  anchorEl?: MutableRefObject<null> | null;
  status: CardStatus;
}

function ActionMenu({
  onArchive,
  onEdit,
  onRestore,
  open,
  anchorEl,
  status,
}: Props) {
  return (
    <Popper
      open={open}
      aria-labelledby="Action menu"
      aria-describedby="Action menu"
      disablePortal
      placement="bottom-start"
      anchorEl={anchorEl ? anchorEl.current : null}
      sx={{ zIndex: 1300 }} // ensure it's above other elements
    >
      <Paper
        sx={{
          padding: 2,
          borderRadius: 2,
          backgroundColor: 'background.paper',
          boxShadow: 3,
          width: 200,
        }}>
        <MenuList>
          <MenuItem onClick={() => onEdit()}>Edit</MenuItem>
          {/* <MenuItem>Duplicate</MenuItem>
      <MenuItem>Version History</MenuItem>*/}
          {status !== CardStatus.Archived && (
            <MenuItem onClick={() => onArchive()}>Archive</MenuItem>
          )}
          {status === CardStatus.Archived && (
            <MenuItem onClick={() => onRestore()}>Restore</MenuItem>
          )}
        </MenuList>
      </Paper>
    </Popper>
  );
}

export default ActionMenu;
